export const QuoteexpiredIcon = ({
  strokeColor = "var(--color-yellow)",
  width = "22",
  height = "22",
  ...props
}: any) => (
  <svg
    {...props}
    width={width}
    height={height}
    viewBox="0 0 98 105"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.25"
      y="0.75"
      width="77.5"
      height="103.5"
      rx="9.25"
      fill="#F9F9FB"
      stroke="#B1BED2"
      strokeWidth="1.5"
    />
    <path
      d="M19.692 18C19.5084 18.0005 19.3324 18.106 19.2026 18.2935C19.0729 18.481 19 18.7351 19 19C19 19.2649 19.0729 19.519 19.2026 19.7065C19.3324 19.894 19.5084 19.9995 19.692 20H70.308C70.4916 19.9995 70.6676 19.894 70.7974 19.7065C70.9271 19.519 71 19.2649 71 19C71 18.7351 70.9271 18.481 70.7974 18.2935C70.6676 18.106 70.4916 18.0005 70.308 18H19.692Z"
      fill="#B1BED2"
    />
    <path
      d="M19.6858 22C19.5042 21.9998 19.33 22.1048 19.2014 22.2919C19.0728 22.479 19.0004 22.7329 19 22.9979C18.9996 23.2629 19.0713 23.5172 19.1994 23.7051C19.3274 23.893 19.5013 23.9991 19.6829 24H51.3147C51.4047 24 51.4938 23.9741 51.577 23.9239C51.6601 23.8736 51.7356 23.8 51.7993 23.7071C51.8629 23.6142 51.9134 23.504 51.9478 23.3827C51.9823 23.2614 52 23.1313 52 23C52 22.8687 51.9823 22.7386 51.9478 22.6173C51.9134 22.496 51.8629 22.3858 51.7993 22.2929C51.7356 22.2 51.6601 22.1264 51.577 22.0761C51.4938 22.0259 51.4047 22 51.3147 22H19.6858Z"
      fill="#B1BED2"
    />
    <path
      d="M19.692 44C19.5084 44.0005 19.3324 44.106 19.2026 44.2935C19.0729 44.481 19 44.7351 19 45C19 45.2649 19.0729 45.519 19.2026 45.7065C19.3324 45.894 19.5084 45.9995 19.692 46H70.308C70.4916 45.9995 70.6676 45.894 70.7974 45.7065C70.9271 45.519 71 45.2649 71 45C71 44.7351 70.9271 44.481 70.7974 44.2935C70.6676 44.106 70.4916 44.0005 70.308 44H19.692Z"
      fill="#B1BED2"
    />
    <path
      d="M19.6858 48C19.5042 47.9998 19.33 48.1048 19.2014 48.2919C19.0728 48.479 19.0004 48.7329 19 48.9979C18.9996 49.2629 19.0713 49.5172 19.1994 49.7051C19.3274 49.893 19.5013 49.9991 19.6829 50H51.3147C51.4965 50 51.6708 49.8946 51.7993 49.7071C51.9278 49.5196 52 49.2652 52 49C52 48.7348 51.9278 48.4804 51.7993 48.2929C51.6708 48.1054 51.4965 48 51.3147 48H19.6858Z"
      fill="#B1BED2"
    />
    <path
      d="M19.692 69C19.5084 69.0005 19.3324 69.106 19.2026 69.2935C19.0729 69.481 19 69.7351 19 70C19 70.2649 19.0729 70.519 19.2026 70.7065C19.3324 70.894 19.5084 70.9995 19.692 71H70.308C70.4916 70.9995 70.6676 70.894 70.7974 70.7065C70.9271 70.519 71 70.2649 71 70C71 69.7351 70.9271 69.481 70.7974 69.2935C70.6676 69.106 70.4916 69.0005 70.308 69H19.692Z"
      fill="#B1BED2"
    />
    <path
      d="M19.6858 73C19.5042 72.9998 19.33 73.1048 19.2014 73.2919C19.0728 73.479 19.0004 73.7329 19 73.9979C18.9996 74.2629 19.0713 74.5172 19.1994 74.7051C19.3274 74.893 19.5013 74.9991 19.6829 75H51.3147C51.4965 75 51.6708 74.8946 51.7993 74.7071C51.9278 74.5196 52 74.2652 52 74C52 73.7348 51.9278 73.4804 51.7993 73.2929C51.6708 73.1054 51.4965 73 51.3147 73H19.6858Z"
      fill="#B1BED2"
    />
    <path
      d="M16 20C16 22.2091 14.2091 24 12 24C9.79086 24 8 22.2091 8 20C8 17.7909 9.79086 16 12 16C14.2091 16 16 17.7909 16 20Z"
      fill="#FF0000"
    />
    <circle cx="12" cy="46" r="4" fill="#FF0000" />
    <circle cx="12" cy="71" r="4" fill="#FF0000" />
    <circle cx="78" cy="76" r="20" fill="#FFE6E6" />
    <path
      d="M73.7997 81.834L77.9997 77.634L82.1997 81.834L83.833 80.2007L79.633 76.0007L83.833 71.8007L82.1997 70.1673L77.9997 74.3673L73.7997 70.1673L72.1663 71.8007L76.3663 76.0007L72.1663 80.2007L73.7997 81.834ZM77.9997 87.6673C76.3858 87.6673 74.8691 87.3609 73.4497 86.748C72.0302 86.1351 70.7955 85.304 69.7455 84.2548C68.6955 83.2048 67.8645 81.9701 67.2523 80.5506C66.6402 79.1312 66.3338 77.6145 66.333 76.0007C66.333 74.3868 66.6395 72.8701 67.2523 71.4507C67.8652 70.0312 68.6963 68.7965 69.7455 67.7465C70.7955 66.6965 72.0302 65.8654 73.4497 65.2533C74.8691 64.6412 76.3858 64.3348 77.9997 64.334C79.6136 64.334 81.1302 64.6404 82.5497 65.2533C83.9691 65.8662 85.2038 66.6973 86.2538 67.7465C87.3038 68.7965 88.1353 70.0312 88.7482 71.4507C89.3611 72.8701 89.6671 74.3868 89.6663 76.0007C89.6663 77.6145 89.3599 79.1312 88.747 80.5506C88.1341 81.9701 87.3031 83.2048 86.2538 84.2548C85.2038 85.3048 83.9691 86.1363 82.5497 86.7491C81.1302 87.362 79.6136 87.6681 77.9997 87.6673ZM77.9997 85.334C80.6052 85.334 82.8122 84.4298 84.6205 82.6215C86.4288 80.8132 87.333 78.6062 87.333 76.0007C87.333 73.3951 86.4288 71.1882 84.6205 69.3798C82.8122 67.5715 80.6052 66.6673 77.9997 66.6673C75.3941 66.6673 73.1872 67.5715 71.3788 69.3798C69.5705 71.1882 68.6663 73.3951 68.6663 76.0007C68.6663 78.6062 69.5705 80.8132 71.3788 82.6215C73.1872 84.4298 75.3941 85.334 77.9997 85.334Z"
      fill="#FF0000"
    />
  </svg>
);
